import React  from 'react'
import {  PDFViewer } from '@react-pdf/renderer';
import HistoryMedicalPDF from './HistoryMedicalPDF';
import HistoryTherapyPDF from './HistoryTherapyPDF';
import HistoryNursePDF from './HistoryNursePDF';
import HistorySocialWorkerPDF from './HistorySocialWorkerPDF';

export default function GeneratePdf(props) {
    return (
        <div style={{ minHeight: "100vh" }}>
             <PDFViewer style={{ width: "100%", height: "90vh" }}>
                 {(props.affiliateInfo.type == "Fisioterapia" 
                    || props.affiliateInfo.type == "Fonoaudiologia" 
                    || props.affiliateInfo.type == "SST OCUPACIONAL" 
                    || props.affiliateInfo.type == "Terapia ocupacional"
                    || props.affiliateInfo.type == "Psicología") 
                 ? <HistoryTherapyPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}/>
                 :  (props.affiliateInfo.type == "Enfermeria") 
                 ? <HistoryNursePDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}/> 
                 : (props.affiliateInfo.type == "Trabajadora Social") ?
                     <HistorySocialWorkerPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}/>
                 : <HistoryMedicalPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}/>} 
              </PDFViewer>
       </div>
    );
}; 